module.exports = __webpack_public_path__ + "static/media/5.99edfff3.JPG";